<template>
  <div>
    <header-component />
    <div class="container-fluid mt--6">
      <div class="card">
        <div class="card-header">
          <h3 class="mb-0" style="text-transform: capitalize">
            Service Requests List
          </h3>
          <div class="text-right col-lg-12 col-5">
            <div class="table-filters">
              <el-tag
                v-for="(tag, index) in filters"
                :key="index"
                :disable-transitions="false"
                closable
                @close="removeFilter(index)"
              >
                <span v-if="tag">
                  {{ tag.field }}:
                  <span style="font-weight: bold">
                    {{ tag.value }}
                    <span />
                  </span>
                </span>
              </el-tag>
            </div>
            <base-button size="sm" type="primary" @click="createServiceRequest"
              >Add New</base-button
            >
            <el-popover
              v-model="filterPopUpVisible"
              placement="left"
              width="550"
            >
              <table-filter @apply="applyFilters" />
              <base-button slot="reference" size="sm" type="primary"
                >Add Filter</base-button
              >
            </el-popover>
          </div>
        </div>

        <el-table
          :data="tableData"
          style="width: 100%"
          border
          header-row-class-name="thead-light"
        >
          <el-table-column label="Number" min-width="15">
            <template slot-scope="scope">
              <span v-if="scope.row.serviceRequestNumber"
                >{{ scope.row.serviceRequestNumber }}
                <span>
                  <badge v-if="scope.row.branch === 'Baner'" type="danger">{{
                    scope.row.branch
                  }}</badge>
                  <badge v-else type="info">Aundh</badge>
                </span>
              </span>
            </template>
          </el-table-column>
          <el-table-column
            label="Created At"
            min-width="15"
            prop="date"
            sortable
          >
            <template slot-scope="scope">{{
              scope.row.date | convertDate
            }}</template>
          </el-table-column>
          <el-table-column
            label="completed At"
            min-width="15"
            prop="date"
            sortable
          >
            <template v-if="scope.row.completedAt" slot-scope="scope">{{
              scope.row.completedAt | convertDate
            }}</template>
          </el-table-column>
          <el-table-column label="Customer" prop="customer" min-width="20">
            <template slot-scope="scope">
              {{ scope.row.users.firstName }}
              {{ scope.row.users.lastName }}
            </template>
          </el-table-column>
          <el-table-column label="Vendor" prop="vendor" min-width="17">
            <template slot-scope="scope">
              <span v-if="scope.row.vendor">
                {{ scope.row.vendor.firstName }}
                {{ scope.row.vendor.lastName }}
              </span>
              <span v-else>--</span>
            </template>
          </el-table-column>
          <el-table-column label="Category" prop="category" min-width="13">
            <template slot-scope="scope">
              <span v-if="scope.row.vendor">{{ scope.row.category }}</span>
              <span v-else>--</span>
            </template>
          </el-table-column>
          <el-table-column label="Status" min-width="13">
            <template slot-scope="scope">
              <el-tag
                v-if="
                  scope.row.status.code && scope.row.status.code === 'pending'
                "
                class="pending-status"
                effect="dark"
                >{{ scope.row.status.label }}</el-tag
              >
              <el-tag
                v-if="
                  scope.row.status.code && scope.row.status.code === 'assigned'
                "
                class="assign-status"
                effect="dark"
                >{{ scope.row.status.label }}</el-tag
              >
              <el-tag
                v-else-if="
                  scope.row.status.code && scope.row.status.code === 'visited'
                "
                class="visited-status"
                effect="dark"
                >{{ scope.row.status.label }}</el-tag
              >
              <el-tag
                v-if="
                  scope.row.status.code &&
                    scope.row.status.code === 'quotation_pending'
                "
                class="quotation-pending-status"
                effect="dark"
                >{{ scope.row.status.label }}</el-tag
              >
              <el-tag
                v-if="
                  scope.row.status.code &&
                    scope.row.status.code === 'quotation_completed'
                "
                class="quotation-completed-status"
                effect="dark"
                >{{ scope.row.status.label }}</el-tag
              >
              <el-tag
                v-if="
                  scope.row.status.code &&
                    scope.row.status.code === 'work_in_progress'
                "
                class="work-status"
                effect="dark"
                >{{ scope.row.status.label }}</el-tag
              >
              <el-tag
                v-else-if="
                  scope.row.status.code &&
                    scope.row.status.code === 'payment_pending'
                "
                class="payment-pending-status"
                effect="dark"
                >{{ scope.row.status.label }}</el-tag
              >
              <el-tag
                v-else-if="
                  scope.row.status.code && scope.row.status.code === 'completed'
                "
                type="success"
                effect="dark"
                >{{ scope.row.status.label }}</el-tag
              >
              <el-tooltip
                :content="scope.row.comments"
                effect="dark"
                placement="right-start"
              >
                <el-tag
                  v-if="
                    scope.row.status.code &&
                      scope.row.status.code === 'cancelled'
                  "
                  type="info"
                  effect="dark"
                >
                  {{ scope.row.status.label }}
                </el-tag>
              </el-tooltip>
              <el-tag
                v-if="scope.row.status && scope.row.status.code === 'billing'"
                class="billing-status"
                effect="dark"
                >{{ scope.row.status.label }}</el-tag
              >
            </template>
          </el-table-column>
          <el-table-column min-width="12">
            <template slot-scope="scope">
              <el-dropdown
                slot="dropdown"
                @command="command => handleAction(scope.row, command)"
              >
                <el-button type="primary" size="mini">
                  Actions
                  <i class="el-icon-arrow-down el-icon--right" />
                </el-button>
                <el-dropdown-menu
                  slot="dropdown"
                  class="dropdown-menu dropdown-menu-arrow show"
                >
                  <el-dropdown-item command="timeline"
                    >Timeline</el-dropdown-item
                  >
                  <el-dropdown-item
                    v-if="scope.row.status.code != 'completed'"
                    command="edit"
                    >Edit</el-dropdown-item
                  >
                  <el-dropdown-item v-if="scope.row.vendorId" command="flow"
                    >Flow</el-dropdown-item
                  >
                  <el-dropdown-item
                    v-if="scope.row.status.code != 'completed'"
                    command="advance"
                    >Make Payment</el-dropdown-item
                  >
                  <el-dropdown-item
                    v-if="
                      scope.row.status.code === 'pending' ||
                        scope.row.status.code === 'assigned'
                    "
                    command="cancelRequest"
                    >Cancel Request</el-dropdown-item
                  >
                  <el-dropdown-item
                    v-if="scope.row.vendorInvoice"
                    command="vendorInvoice"
                    >Show Vendor Invoice</el-dropdown-item
                  >
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
          <template slot="empty">
            <div v-if="loading" class="table-loader" />
            <div v-else>No Data</div>
          </template>
        </el-table>
        <div class="card-footer">
          <div
            v-if="meta"
            slot="footer"
            class="flex-wrap col-12 d-flex justify-content-center justify-content-sm-between"
          >
            <div class>
              <p class="card-category">
                Showing {{ meta.from + 1 }} to {{ meta.to }} of
                {{ meta.total }} entries
                <span v-if="selectedRows.length"
                  >&nbsp; &nbsp; {{ selectedRows.length }} rows selected</span
                >
              </p>
            </div>
            <pagination :meta="meta" @paginate="setPagination" />
          </div>
        </div>
      </div>
      <el-dialog :visible.sync="addServiceRequest" title="Add Service Request">
        <add-serviceRequest @close="addServiceRequest = false" />
      </el-dialog>
      <el-dialog :visible.sync="showAdvance" title="Add Payment">
        <add-advance
          :service-request-id="serviceRequestId"
          @close="showAdvance = false"
        />
      </el-dialog>
      <el-dialog
        :visible.sync="cancelServiceRequest"
        title="Reason"
        width="40%"
      >
        <cancel-serviceRequest @close="cancelServiceRequest = false" />
      </el-dialog>
      <el-dialog
        @open="onDialogOpen"
        @close="onDialogClose"
        :visible.sync="showVendorInvoiceModal"
        title="Vendor Invoice"
        width="50%"
      >
        <vendor-invoice ref="vendorInvoice" />
      </el-dialog>
    </div>
  </div>
</template>

<script>
import {
  Select,
  Option,
  DatePicker,
  Table,
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Dropdown,
  Dialog,
  Tag,
  Button,
  Tooltip,
  Popover,
  Form
} from "element-ui";
import { mapGetters, mapActions, mapMutations, mapState } from "vuex";
import AddServiceRequest from "./AddServiceRequest";
import { format } from "date-fns";
import headerComponent from "../Components/HeaderComponent";
import tableFilter from "@/components/TableFilterComponent";
import pagination from "@/components/AmsaPagination";
import AddAdvance from "./AddAdvance.vue";
import CancelServiceRequest from "./CancelServiceRequest";
import TableFilter from "../../components/ServiceRequestTableFilter";
import VendorInvoiceDesign from "./VendorInvoiceDesign.vue";
export default {
  filters: {
    convertDate(date) {
      return format(date, "YYYY-MM-DD");
    }
  },
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownMenu.name]: DropdownMenu,
    [DropdownItem.name]: DropdownItem,
    [Select.name]: Select,
    [Option.name]: Option,
    [DatePicker.name]: DatePicker,
    [Dialog.name]: Dialog,
    [Tag.name]: Tag,
    [Button.name]: Button,
    pagination,
    [Tooltip.name]: Tooltip,
    [Popover.name]: Popover,
    "add-serviceRequest": AddServiceRequest,
    "header-component": headerComponent,
    "table-filter-component": tableFilter,
    "add-advance": AddAdvance,
    "cancel-serviceRequest": CancelServiceRequest,
    "table-filter": TableFilter,
    "vendor-invoice": VendorInvoiceDesign
  },
  data: () => {
    return {
      addServiceRequest: false,
      cancelServiceRequest: false,
      selectedFilter: null,
      filters: [],
      loading: false,
      visibleFilters: [],
      filterPopUpVisible: false,
      pageSize: 50,
      selectedRows: [],
      searchOptions: {
        options: ["On Site", "In House"],
        dateRange: [new Date(), new Date()]
      },
      showAdvance: false,
      serviceRequestId: null,
      showVendorInvoiceModal: false,
      vendorInvoiceData: null
    };
  },
  computed: {
    ...mapGetters({
      serviceRequest: "serviceRequest/getServiceRequest",
      serviceRequestList: "serviceRequest/getServiceRequestList",
      statusList: "status/getStatusList"
    }),
    ...mapState("serviceRequest", ["serviceRequest"]),
    tableData() {
      return this.serviceRequestList.rows;
    },
    meta() {
      return this.serviceRequestList.meta;
    }
  },

  watch: {
    filters: {
      deep: true,
      handler: function(value, oldValue) {
        this.restructureFilters(value);
      }
    }
  },

  mounted() {
    this.fetchNestedServiceCategories();
    this.getStatusList();
    const data = window.localStorage.getItem("serviceRequestFilters");
    const parsedData = JSON.parse(data);
    if (data != null && parsedData.length != 0) {
      if (parsedData.length > 1) {
        const list = parsedData;
        this.filters.push(...list);
      } else {
        this.filters.push(...parsedData);
      }
    } else {
      this.paginate();
    }
  },

  methods: {
    ...mapActions({
      getServiceRequestList: "serviceRequest/getServiceRequestList",
      fetchServiceRequest: "serviceRequest/fetchServiceRequest",
      getServiceRequestTransactions:
        "serviceRequestTransaction/getServiceRequestTransactions",
      getNestedServiceCategories: "serviceCategory/getNestedServiceCategories",
      updateServiceRequest: "serviceRequest/updateServiceRequest",
      getStatusList: "status/getStatusList",
      getServiceRequestLabors: "serviceRequestLabor/getServiceRequestLabors"
    }),
    ...mapMutations({
      setServiceRequest: "serviceRequest/setServiceRequest",
      resetServiceRequest: "serviceRequest/resetServiceRequest",
      resetServiceRequestTransaction:
        "serviceRequestTransaction/resetServiceRequestTransaction",
      setVendorInvoiceData: "vendor/setVendorInvoiceData"
    }),
    handleAction(serviceRequest, command) {
      if (command === "edit") {
        this.fetchServiceRequest(serviceRequest.serviceRequestId).then(res => {
          this.setServiceRequest(res);
          this.$router.push(
            `/serviceRequests/edit/${serviceRequest.serviceRequestId}`
          );
        });
      } else if (command === "timeline") {
        this.$router.push({
          path: `/serviceRequests/timeline/${serviceRequest.serviceRequestId}`
        });
      } else if (command === "flow") {
        this.fetchServiceRequest(serviceRequest.serviceRequestId).then(
          response => {
            this.$router.push({
              path: `/serviceRequests/flow/${serviceRequest.serviceRequestId}`
            });
          }
        );
      } else if (command === "advance") {
        this.serviceRequestId = serviceRequest.serviceRequestId;
        this.getServiceRequestTransactions(serviceRequest.serviceRequestId);
        this.resetServiceRequestTransaction();
        this.showAdvance = true;
      } else if (command === "cancelRequest") {
        this.fetchServiceRequest(serviceRequest.serviceRequestId).then(res => {
          this.setServiceRequest(res);
          this.cancelServiceRequest = true;
        });
      } else if (command === "vendorInvoice") {
        this.serviceRequestId = serviceRequest.serviceRequestId;
        this.handleShowVendorInvoice(serviceRequest);
      }
    },

    createServiceRequest() {
      this.resetServiceRequest();
      this.$router.push({ path: "/serviceRequests/add" });
    },
    setPagination(data) {
      this.pageSize = data.perPage;
      this.restructureFilters(this.filters, data.page);
    },
    paginate(page = 1, filters = {}) {
      if (filters.type) {
        if (filters.type.toLowerCase() === "on site") {
          filters.type = true;
        } else if (filters.type.toLowerCase() === "in house") {
          filters.type = false;
        }
      }
      let query = {
        page,
        perPage: this.pageSize,
        ...filters
      };
      this.loading = true;
      this.getServiceRequestList(query).then(_ => {
        this.loading = false;
      });
    },
    async fetchNestedServiceCategories() {
      const options = await this.getNestedServiceCategories();
    },
    applyFilters(filters) {
      if (filters.length > 1) {
        this.filters.push(...filters);
      } else {
        this.filters.push(filters);
      }
      window.localStorage.setItem(
        "serviceRequestFilters",
        JSON.stringify(this.filters)
      );
      this.filterPopUpVisible = false;
    },
    removeFilter(tagIndex) {
      if (
        this.filters[tagIndex].field === "attribute" ||
        this.filters[tagIndex].field === "value"
      ) {
        const selectedItem = this.filters.find(
          (_, index) => index === tagIndex
        );
        const item = this.filters.find(i => i.type === selectedItem.type);
        this.filters.splice(tagIndex, 1);
        const index = this.filters.indexOf(item);
        this.filters.splice(index, 1);
      } else {
        this.filters.splice(tagIndex, 1);
      }
      if (this.filters.length > 0) {
        window.localStorage.setItem(
          "serviceRequestFilters",
          JSON.stringify(this.filters)
        );
      } else {
        window.localStorage.removeItem("serviceRequestFilters");
      }
    },
    restructureFilters(value, page = 1) {
      const filtered = {};
      value.forEach(i => {
        if (i.field === "createdAt") {
          filtered.fromDate = i.value[0];
          filtered.toDate = i.value[1];
        } else if (i.field === "completedAt") {
          filtered.fromCompletedDate = i.value[0];
          filtered.toCompletedDate = i.value[1];
        } else {
          filtered[i.field] = i.value;
        }
      });
      if (Object.entries(filtered).length > 0) {
        this.paginate(page, filtered);
      } else {
        this.paginate(page);
      }
    },
    handleShowVendorInvoice(serviceRequest) {
      this.getServiceRequestLabors(this.serviceRequestId).then(res => {
        this.vendorInvoiceData = {
          labors: res,
          vendor: {
            name:
              serviceRequest.vendor.lastName.charAt(0) +
              ". " +
              serviceRequest.vendor.firstName,

            phone: serviceRequest.vendor.phone
          },
          customer: {
            name:
              serviceRequest.users.firstName +
              " " +
              serviceRequest.users.lastName,
            phone: serviceRequest.users.phone
          },
          invoiceNumber: serviceRequest.vendorInvoice,
          invoiceDate: serviceRequest.invoiceDate,
          serviceRequestId: this.serviceRequestId,
          userId: serviceRequest.userId
        };

        this.showVendorInvoiceModal = true;
        this.setVendorInvoiceData(this.vendorInvoiceData);
      });
    },
    onDialogOpen() {
      if (this.$refs && this.$refs.vendorInvoice) {
        this.$refs.vendorInvoice.fetchData(); // Call the fetch function in the child
      }
    },
    onDialogClose() {
      if (this.$refs && this.$refs.vendorInvoice) {
        this.$refs.vendorInvoice.resetProperty();
      }
    }
  }
};
</script>
<style>
.table-filters {
  display: inline-block;
}
.table-filters .el-tag {
  margin-left: 10px;
}
.visited-status {
  background-color: #cdd002;
  border-color: #cdd002;
  color: #fff;
}
.cancelled-status {
  background-color: #b0ccb3;
  border-color: #b0ccb3;
  color: #fff;
}
.payment-pending-status {
  background-color: #b92f36eb;
  border-color: #b92f36eb;
  color: #fff;
}
.pending-status {
  background-color: #e72626;
  border-color: #e72626;
  color: #fff;
}
.quotation-pending-status {
  background-color: #e57585;
  border-color: #e57585;
  color: #fff;
}
.quotation-completed-status {
  background-color: #679f68;
  border-color: #679f68;
  color: #fff;
}
.work-status {
  background-color: #f57316eb;
  border-color: #f57316eb;
  color: #fff;
}
.billing-status {
  background-color: #1a4ddc;
  border-color: #1a4ddc;
  color: #fff;
}
.assign-status {
  background-color: #60c8be;
  border-color: #60c8be;
  color: #fff;
}
</style>
